/* eslint-disable prettier/prettier */
import { get, find, includes } from 'lodash';
import { getItemCode } from '@/lib/item';
import { HITECH_CATEGORIES_LIST } from './constants';

const getters = {
  ShowWhatsNewButton: state => {
    return state.data.ShowWhatsNewButton;
  },
  isNativeDevice: (state) => {
    return state.nativeDevice;
  },

  categoryCode: state => categoryName => {
    let code = state.allCategories.find(
      category => category.NameInHebrew === categoryName
    );

    if (code) return code.Code;
    return;
  },

  categoryName: state => categoryCode => {
    let name = state.allCategories.find(
      category => category.Code === parseInt(categoryCode)
    );
    name = name.NameInHebrew;
    return name;
  },

  subCategoryName: state => subCategoryCode => {
    let name = state.allSubCategories.find(category => {
      return category.Code == parseInt(subCategoryCode);
    });

    name = name.NameInHebrew;
    return name;
  },

  subCategoryCode: state => subCategoryName => {
    let code = state.allSubCategories.find(
      category => category.NameInHebrew === subCategoryName
    );

    if (code) return code.Code;

    return;
  },

  getCategoryItemByName: state => categoryName => {
    let category = state.allCategories.find(
      category => category.NameInHebrew === categoryName
    );
    return category;
  },

  getCategoryItemByCode: state => categoryCode => {


    let category = state.allCategories.find(
      category => category.Code === parseInt(categoryCode)
    );


    return category;
  },

  filteredList: state => searchStr => {
    searchStr = searchStr.toUpperCase();
    let tempArr = [];

    const allItems = [...state.allCategories, ...state.allSubCategories];

    allItems.forEach(item => {
      if (item.NameInHebrew.includes(searchStr)) {
        tempArr.push(item);
      }
      item.Synonyms.forEach(synonym => {
        if (Synonym.includes(searchStr)) {
          tempArr.push({
            Code: getItemCode(item),
            NameInHebrew: synonym
          });
        }
      });
    });
    return tempArr;
  },

  categoriesByCategoryCodes: state => (codes = []) => {
    return state.allCategories.filter(item =>
      includes(codes, getItemCode(item))
    );
  },

  hitechCategories: state => {
    return getters.categoriesByCategoryCodes(state)(HITECH_CATEGORIES_LIST);
  },

  subcatsByCategoryCode: state => categoryCode => {
    const category = find(state.allCategories, { Code: categoryCode });
    return get(category, 'Areas', []);
  },
  subcatsByCode: state => (codes = []) => {
    return state.allSubCategories.filter(cat =>
      includes(codes, getItemCode(cat))
    );
  },

  // Errors
  errors: state => {
    return get(state, 'data.Errors', []);
  },

  // Ads
  ads: state => {
    return get(state, 'data.Ads', []);
  }
};

export default getters;
